import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../../LoadingSpinner";
import Dropdown from "../../../input/Dropdown";
import { FORMS, MODULES } from "../../../../const";
import Button from "../../../input/Button";
import {
  statusAmend,
  timeAmendSelection,
  updatableStatus,
} from "../../../../api/jobApi";
import { toast } from "react-toastify";
import InfoList from "../../../InfoList";
import { Clock, Info } from "react-feather";
import { formatFromJsonDate } from "../../../../dateConfig";
import { getDropdownData } from "../../../../api/keyvalue";
import useUserCompany from "../../../../hooks/useUserCompany";

const JobStatusManager = ({
  jobId,
  reloadData,
  setReloadData,
  status,
  close,
  Header,
  setIsLoading,
  isLoading,
  currentTimeFreeze,
}) => {
  const userCompany = useUserCompany();
  const [currentErrors, setCurrentErrors] = useState({});
  const [statusOptions, setStatusOptions] = useState([]);
  const [timeChangeReqId, setTimeChangeReqId] = useState(null);
  const [statusManager, setStatusManager] = useState({
    status: null,
    rtu: null,
    type: null,
    remark: "",
  });
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [timeRevertSelectionMap, setTimeRevertSelectionMap] = useState({});
  const [timeRevertOptions, setTimeRevertOptions] = useState([]);
  const [showStatusDetails, setShowStatusDetails] = useState(true);
  const [showTimeDetails, setShowTimeDetails] = useState(true);
  const [timeTypeOptions, setTimeTypeOptions] = useState([]);
  const [isEnabled, setIsEnabled] = useState(false);

  const rtuData =
    statusManager.rtu === null
      ? null
      : timeRevertSelectionMap[statusManager.rtu];

  useEffect(() => {
    (async () => {
      if (reloadData) {
        setIsLoading(true);
        const {
          timeChangeRequestedId,
          updatableStatusDropdown,
          isStatusUpdateEnabled,
        } = await updatableStatus({
          jobId,
          currentStatus: status,
        });

        const { timeAmendSelectionDropdown, timeAmendSelectionDropdownMap } =
          await timeAmendSelection({ jobId });

        const timeTypeDropdown = await getDropdownData("time_type");
        setTimeTypeOptions(timeTypeDropdown);
        setTimeRevertOptions(timeAmendSelectionDropdown);
        setTimeRevertSelectionMap(timeAmendSelectionDropdownMap);
        setTimeChangeReqId(timeChangeRequestedId);
        setStatusOptions(updatableStatusDropdown);
        setIsEnabled(isStatusUpdateEnabled);
        setReloadData(false);
        setIsLoading(false);
      }
    })();
  }, [reloadData, status]);

  console.log("current time freeze", currentTimeFreeze);

  const statusUpdateHandler = async (e) => {
    e.preventDefault();

    if (currentTimeFreeze) return;

    let errorObject = {};
    if (!statusManager?.status) {
      errorObject.status = "Status is mandatory";
      return;
    }
    if (statusManager?.status === timeChangeReqId) {
      if (statusManager?.rtu === null) {
        errorObject.rtu = "Location is mandatory";
      }
      if (statusManager?.type === null) {
        errorObject.type = "Type is mandatory";
      }
    }
    if (Object.keys(errorObject).length > 0) {
      setCurrentErrors(errorObject);
      toast.error("Please fill all the mandatory fields", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    setIsSubmitLoading(true);
    try {
      const { statusId, statusName } = await statusAmend({
        jobId,
        rtuId: statusManager.rtu,
        type: statusManager.type,
        status: statusManager.status,
        company: userCompany?.comId,
      });
      // const response = await updateJobStatus({
      //   sUser: user.username,
      //   lRequest: requestId,
      //   lStatus: statusManager.status,
      //   lJob: jobId,
      // });
      setReloadData(true);

      if (statusId < 0) {
        toast.error(statusName, {
          hideProgressBar: false,
          autoClose: 4000,
          containerId: "Modal",
        });
      } else {
        toast.success(`Successfully updated status to ${statusName}`, {
          hideProgressBar: false,
          autoClose: 2000,
          containerId: "Modal",
        });
        // Time out inorder for the user to see the toast.
        setTimeout(() => {
          close();
        }, 2000);
      }
    } catch (e) {
      console.error(e);
      toast.error("An unexpected error occurred", {
        autoClose: 5000,
        containerId: "Main",
      });
    }
    setIsSubmitLoading(false);
  };

  return (
    <>
      <h2>Status Manager</h2>
      <div className="ui segment">
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="ui styled accordion" style={{ width: "100%" }}>
              <div
                className={`title ${showStatusDetails ? "active" : ""}`}
                onClick={() => setShowStatusDetails((prevState) => !prevState)}
              >
                <div>
                  Job Information
                  <Info size={14} style={{ marginLeft: "10px" }} />
                  <i className="dropdown icon"></i>
                </div>
              </div>
              <div className={`content ${showStatusDetails ? "active" : ""}`}>
                <Header />
              </div>
            </div>

            <form
              className="ui form"
              style={{ overflowY: "auto", height: "75vh", marginTop: "10px" }}
            >
              <div className="field">
                <Dropdown
                  disabled={!isEnabled}
                  required={true}
                  clearable={false}
                  search={true}
                  label="Status"
                  error={currentErrors.status}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { status: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={statusOptions}
                  style={{ height: "20px" }}
                  value={statusManager.status}
                  onChange={(e, data) => {
                    setStatusManager((prevState) => ({
                      ...prevState,
                      status: data.value,
                    }));
                  }}
                  module={MODULES.Transaction}
                  form={FORMS.JOB_STATUS.MANAGER.form}
                  field="status"
                  editMode={false}
                />
              </div>
              {statusManager.status === timeChangeReqId && (
                <div className="two fields">
                  <Dropdown
                    disabled={!isEnabled}
                    required={true}
                    clearable={false}
                    search={true}
                    label="Time Information"
                    error={currentErrors.rtu}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { rtu: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    placeholder="Time Information"
                    options={timeRevertOptions}
                    style={{ height: "20px" }}
                    value={statusManager.rtu}
                    onChange={(e, data) => {
                      setStatusManager((prevState) => ({
                        ...prevState,
                        rtu: data.value,
                      }));
                    }}
                    module={MODULES.Transaction}
                    form={FORMS.JOB_STATUS.MANAGER.form}
                    field="rtu"
                    editMode={false}
                  />
                  <Dropdown
                    disabled={!isEnabled}
                    required={true}
                    clearable={false}
                    search={true}
                    label="Time Type"
                    error={currentErrors.type}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { type: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    placeholder="Time Type"
                    options={timeTypeOptions}
                    style={{ height: "20px" }}
                    value={statusManager.type}
                    onChange={(e, data) => {
                      setStatusManager((prevState) => ({
                        ...prevState,
                        type: data.value,
                      }));
                    }}
                    module={MODULES.Transaction}
                    form={FORMS.JOB_STATUS.MANAGER.form}
                    field="type"
                    editMode={false}
                  />
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px 4px",
                }}
              >
                {statusManager.status === timeChangeReqId && rtuData && (
                  <div
                    className="ui styled accordion"
                    style={{
                      width: "100%",
                    }}
                  >
                    <div
                      className={`title ${showTimeDetails ? "active" : ""}`}
                      onClick={() =>
                        setShowTimeDetails((prevState) => !prevState)
                      }
                    >
                      <div>
                        Location Time Information
                        <Clock size={14} style={{ marginLeft: "10px" }} />
                        <i className="dropdown icon"></i>
                      </div>
                    </div>
                    <div
                      className={`content ${showTimeDetails ? "active" : ""}`}
                    >
                      <InfoList
                        content={
                          rtuData
                            ? [
                                {
                                  title: "Location",
                                  value: rtuData.locName ?? "N/A",
                                },
                                {
                                  title: "Type",
                                  value: rtuData.keyValue1 ?? "N/A",
                                },
                                {
                                  title: "Arrival",
                                  value: rtuData.rtuArrivalTime
                                    ? formatFromJsonDate(rtuData.rtuArrivalTime)
                                    : "N/A",
                                },
                                {
                                  title: "Departure",
                                  value: rtuData.rtuDepartureTime
                                    ? formatFromJsonDate(
                                        rtuData.rtuDepartureTime,
                                      )
                                    : "N/A",
                                },
                              ]
                            : []
                        }
                        showHeader={false}
                        showSegment={false}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                  gap: "5px",
                }}
              >
                <Button
                  disabled={!isEnabled || currentTimeFreeze}
                  template="submit"
                  form={FORMS.JOB_STATUS.MANAGER.form}
                  module={MODULES.Transaction}
                  authenticated={true}
                  editMode={true}
                  create={false}
                  onClick={statusUpdateHandler}
                  isLoading={isSubmitLoading}
                />
              </div>
            </form>
          </>
        )}
      </div>
    </>
  );
};

export default JobStatusManager;
